function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000089556267857126763960000000646407498019787698_);}\n\t.st2{fill:#804EF9;}\n\t.st3{fill:#FFC543;}\n\t.st4{fill:#FFB6BB;}\n\t.st5{fill:#4CFCC6;}\n\t.st6{fill:#BC99FF;}\n\t.st7{fill:#1A46FF;}\n\t.st8{fill:none;stroke:#562BD8;stroke-miterlimit:10;}\n\t.st9{fill:#562BD8;}\n\t.st10{fill:none;stroke:#BC99FF;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "BACKGROUND"
}, React.createElement("rect", {
  className: "st0",
  width: 750,
  height: 500
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "SVGID_1_",
  width: 750,
  height: 500
}));

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: -61.1,
  y: -40.6,
  className: "st2",
  width: 213,
  height: 213
});

var _ref6 =
/*#__PURE__*/
React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -298.0081 249.2462)",
  className: "st3",
  cx: 151.9,
  cy: 484.4,
  rx: 176.2,
  ry: 176.2
});

var _ref7 =
/*#__PURE__*/
React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 202.1542 362.2152)",
  className: "st4",
  cx: 538.3,
  cy: -62.9,
  rx: 176.2,
  ry: 176.2
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st4",
  d: "M329.7,276.8H112.2C61.8,276.8,21,236,21,185.6v0c0-50.4,40.8-91.2,91.2-91.2h217.5V276.8z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st5",
  d: "M546.7,377.3V108.2c0-50.4,40.8-91.2,91.2-91.2h0c50.4,0,91.2,40.8,91.2,91.2v269.1H546.7z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st6",
  d: "M424.9,377.3h-213v0c0-117.6,95.4-213,213-213h0V377.3z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 424.9,
  y: 164.3,
  className: "st2",
  width: 213,
  height: 213
});

var _ref12 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st7",
  points: "156.4,249 184.2,249 184.2,276.8  "
}), React.createElement("polygon", {
  className: "st7",
  points: "184.2,249 211.9,249 211.9,276.8  "
}), React.createElement("polygon", {
  className: "st7",
  points: "211.9,249 239.7,249 239.7,276.8  "
}), React.createElement("polygon", {
  className: "st7",
  points: "239.7,249 267.4,249 267.4,276.8  "
})), React.createElement("g", null, React.createElement("polygon", {
  className: "st7",
  points: "156.4,276.8 184.2,276.8 184.2,304.5  "
}), React.createElement("polygon", {
  className: "st7",
  points: "184.2,276.8 211.9,276.8 211.9,304.5  "
}), React.createElement("polygon", {
  className: "st7",
  points: "211.9,276.8 239.7,276.8 239.7,304.5  "
}), React.createElement("polygon", {
  className: "st7",
  points: "239.7,276.8 267.4,276.8 267.4,304.5  "
})));

var _ref13 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st7",
  points: "673.6,67.2 701.3,67.2 701.3,95  "
}), React.createElement("polygon", {
  className: "st7",
  points: "701.3,67.2 729.1,67.2 729.1,95  "
}), React.createElement("polygon", {
  className: "st7",
  points: "729.1,67.2 756.8,67.2 756.8,95  "
}), React.createElement("polygon", {
  className: "st7",
  points: "756.8,67.2 784.6,67.2 784.6,95  "
})), React.createElement("g", null, React.createElement("polygon", {
  className: "st7",
  points: "673.6,95 701.3,95 701.3,122.7  "
}), React.createElement("polygon", {
  className: "st7",
  points: "701.3,95 729.1,95 729.1,122.7  "
}), React.createElement("polygon", {
  className: "st7",
  points: "729.1,95 756.8,95 756.8,122.7  "
}), React.createElement("polygon", {
  className: "st7",
  points: "756.8,95 784.6,95 784.6,122.7  "
})));

var _ref14 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st4",
  points: "704.9,175.9 704.9,243 637.8,243 637.8,310.1 637.8,310.1 637.8,310.1 637.8,310.1 570.7,310.1  570.7,377.3 570.7,377.3 503.5,377.3 503.5,444.4 503.5,444.4 436.4,444.4 436.4,511.5 369.3,511.5 369.3,578.7 436.4,578.7  772,578.7 772,243 772,175.9  "
});

var _ref15 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 172.2,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 187.9,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 203.7,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 219.4,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 235.2,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 251,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 266.7,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 282.5,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 298.2,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 314,
  y: 79.1,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 172.2,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 187.9,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 203.7,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 219.4,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 235.2,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 251,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 266.7,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 282.5,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 298.2,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 314,
  y: 94.9,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 172.2,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 187.9,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 203.7,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 219.4,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 235.2,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 251,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 266.7,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 282.5,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 298.2,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 314,
  y: 110.6,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 172.2,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 187.9,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 203.7,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 219.4,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 235.2,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 251,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 266.7,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 282.5,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 298.2,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 314,
  y: 126.4,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 172.2,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 187.9,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 203.7,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 219.4,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 235.2,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 251,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 266.7,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 282.5,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 298.2,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 314,
  y: 142.1,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 172.2,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 187.9,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 203.7,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 219.4,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 235.2,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 251,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 266.7,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 282.5,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 298.2,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 314,
  y: 157.9,
  className: "st8",
  width: 15.8,
  height: 15.8
})));

var _ref16 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 570.7,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 586.4,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 602.2,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 617.9,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 633.7,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 649.4,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 665.2,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 680.9,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 696.7,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 712.5,
  y: 377.3,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 570.7,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 586.4,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 602.2,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 617.9,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 633.7,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 649.4,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 665.2,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 680.9,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 696.7,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 712.5,
  y: 393,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 570.7,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 586.4,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 602.2,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 617.9,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 633.7,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 649.4,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 665.2,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 680.9,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 696.7,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 712.5,
  y: 408.8,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 570.7,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 586.4,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 602.2,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 617.9,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 633.7,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 649.4,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 665.2,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 680.9,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 696.7,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 712.5,
  y: 424.5,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 570.7,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 586.4,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 602.2,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 617.9,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 633.7,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 649.4,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 665.2,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 680.9,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 696.7,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 712.5,
  y: 440.3,
  className: "st8",
  width: 15.8,
  height: 15.8
})), React.createElement("g", null, React.createElement("rect", {
  x: 570.7,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 586.4,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 602.2,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 617.9,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 633.7,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 649.4,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 665.2,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 680.9,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 696.7,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
}), React.createElement("rect", {
  x: 712.5,
  y: 456.1,
  className: "st8",
  width: 15.8,
  height: 15.8
})));

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 468.2,
  y: 113.2,
  className: "st3",
  width: 121.5,
  height: 22.6
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 682.2,
  y: 320.7,
  className: "st7",
  width: 121.5,
  height: 22.6
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 222.2,
  y: 477.4,
  className: "st5",
  width: 121.5,
  height: 22.6
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: -31.2,
  y: 332,
  className: "st2",
  width: 121.5,
  height: 22.6
});

var _ref21 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st2",
  cx: 556.7,
  cy: 65.3,
  r: 18.4
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st5",
  cx: 423.5,
  cy: 313.6,
  r: 18.4
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0",
  cx: 715.2,
  cy: 500,
  r: 18.4
});

var _ref24 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st5",
  points: "435.7,472.3 463.5,472.3 463.5,500  "
}), React.createElement("polygon", {
  className: "st5",
  points: "463.5,472.3 491.2,472.3 491.2,500  "
}), React.createElement("polygon", {
  className: "st5",
  points: "491.2,472.3 518.9,472.3 518.9,500  "
}), React.createElement("polygon", {
  className: "st5",
  points: "518.9,472.3 546.7,472.3 546.7,500  "
})), React.createElement("g", null, React.createElement("polygon", {
  className: "st5",
  points: "435.7,500 463.5,500 463.5,527.7  "
}), React.createElement("polygon", {
  className: "st5",
  points: "463.5,500 491.2,500 491.2,527.7  "
}), React.createElement("polygon", {
  className: "st5",
  points: "491.2,500 518.9,500 518.9,527.7  "
}), React.createElement("polygon", {
  className: "st5",
  points: "518.9,500 546.7,500 546.7,527.7  "
})));

var _ref25 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st5",
  points: "68.6,0 96.4,0 96.4,27.7  "
}), React.createElement("polygon", {
  className: "st5",
  points: "96.4,0 124.1,0 124.1,27.7  "
}), React.createElement("polygon", {
  className: "st5",
  points: "124.1,0 151.9,0 151.9,27.7  "
}), React.createElement("polygon", {
  className: "st5",
  points: "151.9,0 179.6,0 179.6,27.7  "
})), React.createElement("g", null, React.createElement("polygon", {
  className: "st5",
  points: "68.6,27.7 96.4,27.7 96.4,55.5  "
}), React.createElement("polygon", {
  className: "st5",
  points: "96.4,27.7 124.1,27.7 124.1,55.5  "
}), React.createElement("polygon", {
  className: "st5",
  points: "124.1,27.7 151.9,27.7 151.9,55.5  "
}), React.createElement("polygon", {
  className: "st5",
  points: "151.9,27.7 179.6,27.7 179.6,55.5  "
})));

var _ref26 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M16.4,200c0,0.7-0.5,1.2-1.2,1.2S14,200.7,14,200c0-0.7,0.5-1.2,1.2-1.2S16.4,199.4,16.4,200z"
}), React.createElement("path", {
  className: "st9",
  d: "M36.4,200c0,0.7-0.5,1.2-1.2,1.2S34,200.7,34,200c0-0.7,0.5-1.2,1.2-1.2S36.4,199.4,36.4,200z"
}), React.createElement("path", {
  className: "st9",
  d: "M56.3,200c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C55.8,198.8,56.3,199.4,56.3,200z"
}), React.createElement("path", {
  className: "st9",
  d: "M76.3,200c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C75.7,198.8,76.3,199.4,76.3,200z"
}), React.createElement("path", {
  className: "st9",
  d: "M96.2,200c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C95.7,198.8,96.2,199.4,96.2,200z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M16.4,213.7c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S16.4,213,16.4,213.7z"
}), React.createElement("path", {
  className: "st9",
  d: "M36.4,213.7c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S36.4,213,36.4,213.7z"
}), React.createElement("path", {
  className: "st9",
  d: "M56.3,213.7c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C55.8,212.4,56.3,213,56.3,213.7z"
}), React.createElement("path", {
  className: "st9",
  d: "M76.3,213.7c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C75.7,212.4,76.3,213,76.3,213.7z"
}), React.createElement("path", {
  className: "st9",
  d: "M96.2,213.7c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C95.7,212.4,96.2,213,96.2,213.7z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M16.4,227.3c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S16.4,226.6,16.4,227.3z"
}), React.createElement("path", {
  className: "st9",
  d: "M36.4,227.3c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S36.4,226.6,36.4,227.3z"
}), React.createElement("path", {
  className: "st9",
  d: "M56.3,227.3c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C55.8,226,56.3,226.6,56.3,227.3z"
}), React.createElement("path", {
  className: "st9",
  d: "M76.3,227.3c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C75.7,226,76.3,226.6,76.3,227.3z"
}), React.createElement("path", {
  className: "st9",
  d: "M96.2,227.3c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C95.7,226,96.2,226.6,96.2,227.3z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M16.4,240.9c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S16.4,240.2,16.4,240.9z"
}), React.createElement("path", {
  className: "st9",
  d: "M36.4,240.9c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S36.4,240.2,36.4,240.9z"
}), React.createElement("path", {
  className: "st9",
  d: "M56.3,240.9c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C55.8,239.6,56.3,240.2,56.3,240.9z"
}), React.createElement("path", {
  className: "st9",
  d: "M76.3,240.9c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C75.7,239.6,76.3,240.2,76.3,240.9z"
}), React.createElement("path", {
  className: "st9",
  d: "M96.2,240.9c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C95.7,239.6,96.2,240.2,96.2,240.9z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M16.4,254.5c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S16.4,253.8,16.4,254.5z"
}), React.createElement("path", {
  className: "st9",
  d: "M36.4,254.5c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S36.4,253.8,36.4,254.5z"
}), React.createElement("path", {
  className: "st9",
  d: "M56.3,254.5c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C55.8,253.3,56.3,253.8,56.3,254.5z"
}), React.createElement("path", {
  className: "st9",
  d: "M76.3,254.5c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C75.7,253.3,76.3,253.8,76.3,254.5z"
}), React.createElement("path", {
  className: "st9",
  d: "M96.2,254.5c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C95.7,253.3,96.2,253.8,96.2,254.5z"
})));

var _ref27 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M345.2,406c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S345.2,405.3,345.2,406z"
}), React.createElement("path", {
  className: "st9",
  d: "M365.1,406c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C364.6,404.8,365.1,405.3,365.1,406z"
}), React.createElement("path", {
  className: "st9",
  d: "M385.1,406c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C384.5,404.8,385.1,405.3,385.1,406z"
}), React.createElement("path", {
  className: "st9",
  d: "M405,406c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C404.5,404.8,405,405.3,405,406z"
}), React.createElement("path", {
  className: "st9",
  d: "M424.9,406c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C424.4,404.8,424.9,405.3,424.9,406z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M345.2,419.6c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S345.2,418.9,345.2,419.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M365.1,419.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C364.6,418.4,365.1,418.9,365.1,419.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M385.1,419.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C384.5,418.4,385.1,418.9,385.1,419.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M405,419.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C404.5,418.4,405,418.9,405,419.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M424.9,419.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C424.4,418.4,424.9,418.9,424.9,419.6z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M345.2,433.2c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S345.2,432.5,345.2,433.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M365.1,433.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C364.6,432,365.1,432.5,365.1,433.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M385.1,433.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C384.5,432,385.1,432.5,385.1,433.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M405,433.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C404.5,432,405,432.5,405,433.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M424.9,433.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C424.4,432,424.9,432.5,424.9,433.2z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M345.2,446.8c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S345.2,446.1,345.2,446.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M365.1,446.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C364.6,445.6,365.1,446.1,365.1,446.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M385.1,446.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C384.5,445.6,385.1,446.1,385.1,446.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M405,446.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C404.5,445.6,405,446.1,405,446.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M424.9,446.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C424.4,445.6,424.9,446.1,424.9,446.8z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M345.2,460.4c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S345.2,459.8,345.2,460.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M365.1,460.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C364.6,459.2,365.1,459.8,365.1,460.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M385.1,460.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C384.5,459.2,385.1,459.8,385.1,460.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M405,460.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C404.5,459.2,405,459.8,405,460.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M424.9,460.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C424.4,459.2,424.9,459.8,424.9,460.4z"
})));

var _ref28 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M438.7-8.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C438.1-10,438.7-9.5,438.7-8.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M458.6-8.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C458.1-10,458.6-9.5,458.6-8.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M478.6-8.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C478-10,478.6-9.5,478.6-8.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M498.5-8.8c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S498.5-9.5,498.5-8.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M518.4-8.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C517.9-10,518.4-9.5,518.4-8.8z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M438.7,4.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C438.1,3.6,438.7,4.1,438.7,4.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M458.6,4.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C458.1,3.6,458.6,4.1,458.6,4.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M478.6,4.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C478,3.6,478.6,4.1,478.6,4.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M498.5,4.8c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S498.5,4.1,498.5,4.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M518.4,4.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C517.9,3.6,518.4,4.1,518.4,4.8z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M438.7,18.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C438.1,17.2,438.7,17.8,438.7,18.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M458.6,18.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C458.1,17.2,458.6,17.8,458.6,18.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M478.6,18.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C478,17.2,478.6,17.8,478.6,18.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M498.5,18.4c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S498.5,17.8,498.5,18.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M518.4,18.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C517.9,17.2,518.4,17.8,518.4,18.4z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M438.7,32c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C438.1,30.8,438.7,31.4,438.7,32z"
}), React.createElement("path", {
  className: "st9",
  d: "M458.6,32c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C458.1,30.8,458.6,31.4,458.6,32z"
}), React.createElement("path", {
  className: "st9",
  d: "M478.6,32c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C478,30.8,478.6,31.4,478.6,32z"
}), React.createElement("path", {
  className: "st9",
  d: "M498.5,32c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S498.5,31.4,498.5,32z"
}), React.createElement("path", {
  className: "st9",
  d: "M518.4,32c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C517.9,30.8,518.4,31.4,518.4,32z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M438.7,45.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C438.1,44.4,438.7,45,438.7,45.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M458.6,45.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C458.1,44.4,458.6,45,458.6,45.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M478.6,45.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C478,44.4,478.6,45,478.6,45.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M498.5,45.6c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S498.5,45,498.5,45.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M518.4,45.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C517.9,44.4,518.4,45,518.4,45.6z"
})));

var _ref29 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M684.6,249.6c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S684.6,248.9,684.6,249.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M704.6,249.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C704,248.4,704.6,248.9,704.6,249.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M724.5,249.6c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S724.5,248.9,724.5,249.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M744.4,249.6c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S744.4,248.9,744.4,249.6z"
}), React.createElement("path", {
  className: "st9",
  d: "M764.4,249.6c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C763.8,248.4,764.4,248.9,764.4,249.6z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M684.6,263.2c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S684.6,262.5,684.6,263.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M704.6,263.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C704,262,704.6,262.5,704.6,263.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M724.5,263.2c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S724.5,262.5,724.5,263.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M744.4,263.2c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S744.4,262.5,744.4,263.2z"
}), React.createElement("path", {
  className: "st9",
  d: "M764.4,263.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C763.8,262,764.4,262.5,764.4,263.2z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M684.6,276.8c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S684.6,276.1,684.6,276.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M704.6,276.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C704,275.6,704.6,276.1,704.6,276.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M724.5,276.8c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S724.5,276.1,724.5,276.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M744.4,276.8c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S744.4,276.1,744.4,276.8z"
}), React.createElement("path", {
  className: "st9",
  d: "M764.4,276.8c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C763.8,275.6,764.4,276.1,764.4,276.8z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M684.6,290.4c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S684.6,289.7,684.6,290.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M704.6,290.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C704,289.2,704.6,289.7,704.6,290.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M724.5,290.4c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S724.5,289.7,724.5,290.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M744.4,290.4c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S744.4,289.7,744.4,290.4z"
}), React.createElement("path", {
  className: "st9",
  d: "M764.4,290.4c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C763.8,289.2,764.4,289.7,764.4,290.4z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st9",
  d: "M684.6,304c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S684.6,303.3,684.6,304z"
}), React.createElement("path", {
  className: "st9",
  d: "M704.6,304c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C704,302.8,704.6,303.3,704.6,304z"
}), React.createElement("path", {
  className: "st9",
  d: "M724.5,304c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S724.5,303.3,724.5,304z"
}), React.createElement("path", {
  className: "st9",
  d: "M744.4,304c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2S744.4,303.3,744.4,304z"
}), React.createElement("path", {
  className: "st9",
  d: "M764.4,304c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C763.8,302.8,764.4,303.3,764.4,304z"
})));

var _ref30 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("circle", {
  className: "st10",
  cx: 505.1,
  cy: 255.7,
  r: 55.7
}), React.createElement("circle", {
  className: "st10",
  cx: 505.1,
  cy: 255.7,
  r: 46.7
}), React.createElement("circle", {
  className: "st10",
  cx: 505.1,
  cy: 255.7,
  r: 37.7
}), React.createElement("circle", {
  className: "st10",
  cx: 505.1,
  cy: 255.7,
  r: 28.7
}), React.createElement("circle", {
  className: "st10",
  cx: 505.1,
  cy: 255.7,
  r: 19.7
}), React.createElement("circle", {
  className: "st10",
  cx: 505.1,
  cy: 255.7,
  r: 10.7
}));

var _ref31 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -292.9032 237.3916)",
  className: "st8",
  cx: 140.1,
  cy: 472.3,
  rx: 55.7,
  ry: 55.7
}), React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -292.9032 237.3916)",
  className: "st8",
  cx: 140.1,
  cy: 472.3,
  rx: 46.7,
  ry: 46.7
}), React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -292.9032 237.3916)",
  className: "st8",
  cx: 140.1,
  cy: 472.3,
  rx: 37.7,
  ry: 37.7
}), React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -292.9032 237.3916)",
  className: "st8",
  cx: 140.1,
  cy: 472.3,
  rx: 28.7,
  ry: 28.7
}), React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -292.9032 237.3916)",
  className: "st8",
  cx: 140.1,
  cy: 472.3,
  rx: 19.7,
  ry: 19.7
}), React.createElement("ellipse", {
  transform: "matrix(0.7634 -0.6459 0.6459 0.7634 -271.8824 202.2128)",
  className: "st8",
  cx: 140.1,
  cy: 472.3,
  rx: 10.7,
  ry: 10.7
}));

var _ref32 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 80.1148 213.8708)",
  className: "st8",
  cx: 298.2,
  cy: 10.2,
  rx: 55.7,
  ry: 55.7
}), React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 80.1148 213.8708)",
  className: "st8",
  cx: 298.2,
  cy: 10.2,
  rx: 46.7,
  ry: 46.7
}), React.createElement("ellipse", {
  transform: "matrix(0.8442 -0.536 0.536 0.8442 40.967 161.4264)",
  className: "st8",
  cx: 298.2,
  cy: 10.2,
  rx: 37.7,
  ry: 37.7
}), React.createElement("ellipse", {
  transform: "matrix(0.8422 -0.5391 0.5391 0.8422 41.5337 162.3865)",
  className: "st8",
  cx: 298.2,
  cy: 10.2,
  rx: 28.7,
  ry: 28.7
}), React.createElement("ellipse", {
  transform: "matrix(0.9476 -0.3194 0.3194 0.9476 12.3522 95.7822)",
  className: "st8",
  cx: 298.2,
  cy: 10.2,
  rx: 19.7,
  ry: 19.7
}), React.createElement("ellipse", {
  transform: "matrix(0.8007 -0.5991 0.5991 0.8007 53.3064 180.6904)",
  className: "st8",
  cx: 298.2,
  cy: 10.2,
  rx: 10.7,
  ry: 10.7
}));

var _ref33 =
/*#__PURE__*/
React.createElement("ellipse", {
  transform: "matrix(0.9928 -0.1195 0.1195 0.9928 0.9646 28.155)",
  className: "st7",
  cx: 235.2,
  cy: 6,
  rx: 18.4,
  ry: 18.4
});

var _ref34 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st5",
  d: "M373.9,162.4c0-9.9,8.1-18,18-18v-18c-19.9,0-36,16.1-36,36s16.1,36,36,36v-18 C382,180.4,373.9,172.4,373.9,162.4z"
}));

var _ref35 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st7",
  d: "M14,448.2c0,9.9-8.1,18-18,18v18c19.9,0,36-16.1,36-36s-16.1-36-36-36v18C5.9,430.2,14,438.2,14,448.2z"
}));

var _ref36 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st7",
  d: "M641.6,16.6c0,9.9-8.1,18-18,18v18c19.9,0,36-16.1,36-36s-16.1-36-36-36v18C633.5-1.4,641.6,6.7,641.6,16.6 z"
}));

var _ref37 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st2",
  d: "M496.1,426.4c9.9,0,18,8.1,18,18h18c0-19.9-16.1-36-36-36c-19.9,0-36,16.1-36,36h18 C478.1,434.5,486.1,426.4,496.1,426.4z"
}));

var _ref38 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st6",
  d: "M18.1,126.4c9.9,0,18,8.1,18,18h18c0-19.9-16.1-36-36-36s-36,16.1-36,36h18C0.1,134.5,8.1,126.4,18.1,126.4 z"
}));

var _ref39 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0",
  cx: 165.7,
  cy: 411.2,
  r: 18.4
});

var SvgRetroBg = function SvgRetroBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, React.createElement("g", {
    id: "OBJECTS"
  }, React.createElement("g", null, _ref4, React.createElement("clipPath", {
    id: "SVGID_00000140001478272706246590000011953349175162411694_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140001478272706246590000011953349175162411694_)"
    }
  }, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRetroBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/retro_bg.44805bcd.svg";
export { ForwardRef as ReactComponent };